import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import DataContainer from '../../../Shared/DataContainer';
import DropdownButton from '../../../Shared/DropdownButton';
import Pagination from '../../../Shared/Pagination';
import Icon from '../../../Shared/Icon';
import { can, currencyFormat } from '../../../utils';
import ReactToPrint from "react-to-print";

const Print = () => {
     const { auth, app, data } = usePage().props;
     let componentRef = null;
     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Print Receipt</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Print Receipt</span>
               </div>
               <DataContainer>
                    <ReactToPrint
                         trigger={() => <a className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" href="#">Imprimer</a>}
                         content={() => componentRef}
                    />
               </DataContainer>
               {data && (<div className="flex justify-center my-6">
                    <div className="flex flex-col w-full p-8 text-gray-800 bg-white pin-r pin-y md:w-4/5 lg:w-4/5 pb-5" ref={el => (componentRef = el)}>
                         <div className="flex w-full text-sm">
                              <div className="w-1/4 px-3 py-3"></div>
                              <div className="w-1/2 px-3 py-3 text-center border-b">
                                   <img src={app.mhd.logo_simple_simple} className="mx-auto w-20" />
                                   <h1 className="font-semibold text-2xl text-green-800 font-italic">{app.name}</h1>
                                   <h3 className="font-md text-gray-600">{app.address}</h3>
                                   <h3 className="font-md text-gray-600">{app.phone}</h3>
                                   <h3 className="font-md text-gray-600">{app.email}</h3>
                              </div>
                         </div>
                         <div className="flex w-full text-md">
                              <div className="w-full text-center">
                                   <h1 className="font-bold text-md uppercase text-gray-600">Reçu</h1>
                              </div>
                         </div>
                         <div className="flex w-full text-sm">
                              <div className="w-1/2 p-1">
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 mr-2 text-gray-700">No. Reçu <span className="font-semibold float-right text-gray-600">{data.number}</span></div>
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 mr-2 text-gray-700">No. Référence <span className="font-semibold float-right text-gray-600">{data.reference}</span></div>
                                        <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 text-gray-700">No. POS <span className="font-semibold float-right text-gray-600">{data.accpac}</span></div>
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 mr-2 text-gray-700">Expéditeur <span className="font-semibold float-right text-gray-600">{data.sender.name}</span></div>
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 mr-2 text-gray-700">E-mail <span className="font-semibold float-right text-gray-600">{data.sender.email}</span></div>
                              </div>
                              <div className="w-1/2 p-1">
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 text-gray-700">Bénéficiaire <span className="font-semibold float-right text-gray-600">{data.reciever.name}</span></div>
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 text-gray-700">Adresse <span className="font-semibold float-right text-gray-600">{data.reciever.address}</span></div>
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 text-gray-700">Téléhone <span className="font-semibold float-right text-gray-600">{data.reciever.phone}</span></div>
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 text-gray-700">Date Achat <span className="font-semibold float-right text-gray-600">{data.created}</span></div>
                                   <div className="text-sm font-semibold p-1 bg-gray-100 mt-1 text-gray-700">Sortie le <span className="font-semibold float-right text-gray-600">{data.delivered}</span></div>
                              </div>
                         </div>
                         <div className="block">
                              <div className="py-3">
                                   <div className="border-t border-gray-400"></div>
                              </div>
                         </div>
                         <table className="table-fixed col-span-12 mb-5 text-sm">
                              <thead className="bg-gray-100">
                                   <tr>
                                        <th className="px-4 py-2">Produit</th>
                                        <th className="px-4 py-2">Quantité</th>
                                        <th className="px-4 py-2">Prix Ref.</th>
                                        <th className="px-4 py-2">Prix</th>
                                        <th className="px-4 py-2">Total</th>
                                   </tr>
                              </thead>
                              <tbody>
                                   {data.details.map(({id, name, type, category, code, currency, quantity, price, newprice, total, packs, isCheck}) => {
                                        return <tr key={id}>
                                             <td className="border px-4 py-2">
                                                  {name} <span className="text-xs text-gray-500">({code})</span>
                                                  {packs && (<p className="ml-4 text-xs text-gray-600">{packs.join(' | ')}</p>)}
                                             </td>
                                             <td className="border px-4 py-2 text-center">{quantity}</td>
                                             <td className="border px-4 py-2 text-right">{price.toFixed(2)}</td>
                                             <td className="border px-4 py-2 text-center">{newprice.toFixed(2)}</td>
                                             <td className="border px-4 py-2 text-right">{currencyFormat(total, currency)}</td>
                                        </tr>
                                   })}
                              </tbody>
                              <tfoot>
                                   <tr className="font-semibold">
                                        <td className="px-4 py-2 text-right" colSpan="4">Total</td>
                                        <td className="px-4 py-2 text-right" >{currencyFormat(data.amount, data.currency)}</td>
                                   </tr>
                                   <tr className="font-semibold">
                                        <td className="px-4 py-1 text-right" colSpan="4">Livraison</td>
                                        <td className="px-4 py-1 text-right" >{currencyFormat(data.delivery, data.currency)}</td>
                                   </tr>
                                   <tr className="font-bold">
                                        <td className="px-4 py-1 text-right" colSpan="4">Total Payé</td>
                                        <td className="px-4 py-1 text-right" >{currencyFormat(data.total, data.currency)}</td>
                                   </tr>
                              </tfoot>
                         </table>
                         <div className="flex w-full mt-5 pt-5">
                              <div className="w-1/3 px-3 py-3">
                                   <p className="border-t w-full p-t4 text-gray-700 text-md text-center">Rec: {data.reciever.name}</p>
                              </div>
                              <div className="w-1/3 px-3 py-3"></div>
                              <div className="w-1/3 px-3 py-3">
                                   <p className="border-t w-full p-t4 text-gray-700 text-md text-center">MHD: {data.user}</p>
                              </div>
                         </div>
                         <h1 className="font-bold text-center text-sm uppercase text-gray-600 mb-5">Merci de votre confiance en nous !</h1>
                    </div>
               </div>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Print.layout = page => <AdminLayout children={page} header={'Receipt'} />;

export default Print;
